import { render, staticRenderFns } from "./MPopupUploadImgDrag.vue?vue&type=template&id=d645fb7a&"
import script from "./MPopupUploadImgDrag.ts?vue&type=script&lang=ts&"
export * from "./MPopupUploadImgDrag.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports